<template>
    <v-select 
       :value="selected_acco" 
       v-bind:items="filteredaccos"
       item-value="code" 
       item-text="description" 
       :label="label"
       :dense="isDense" 
       :clearable="isClearable"
       @change="updateData">
       <template v-slot:prepend-item>
            <v-list-item>
                <v-list-item-content>
                    <v-text-field v-model="searchacco" placeholder="Search" :clearable="true"></v-text-field>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>       
    </v-select>
</template>

<script>
export default {
    props: {
        selected_acco: {
            type: String,
            default: ''
        },              
        label: String,
        field: {
            type: String,
            default: 'eign_code',
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
        isDense:{
            type: Boolean,
            default: true
        }
    },
    created() {
        this.getAccos();
    },    
    data() {
        return {
            accos: [],
            searchacco: ''
        }
    },    
    computed:{
      filteredaccos(){
        let acco_array = this.accos
        if(this.searchacco){
            acco_array = acco_array.filter(x => {
                return x.description.toLowerCase().indexOf(this.searchacco.toLowerCase()) > -1
          })
        }
        return acco_array
      }
    },    
    methods: {
        getAccos() {
            this.$axios
                .post("ares/json/ares/huis/getHuisList.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAcco"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', res.data.error.message);
                    } else {
                        console.log(res.data)
                        this.accos = res.data.getAcco;
                    }
                })
        },
        updateData(v){
            // the prop must be updated. You cannot do it directly 
            // so you must update the parent field with an emit
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
            this.searchacco=''; // reset search field
        }
    }
}

</script>